import Cookies from 'js-cookie';

export const utmsController = () => {
    const utms = new URLSearchParams(window.location.search);

    if (utms.has('utm_source')) {
        Cookies.set('utm_source', utms.get('utm_source'), { expires: 30 });
    }

    if (utms.has('utm_medium')) {
        Cookies.set('utm_medium', utms.get('utm_medium'), { expires: 30 });
    }

    if (utms.has('utm_campaign')) {
        Cookies.set('utm_campaign', utms.get('utm_campaign'), { expires: 30 });
    }

    if (utms.has('utm_content')) {
        Cookies.set('utm_content', utms.get('utm_content'), { expires: 30 });
    }

    if (utms.has('utm_term')) {
        Cookies.set('utm_term', utms.get('utm_term'), { expires: 30 });
    }
};
